import { useCallback } from 'react';
import { useEffect } from 'react';
import { Setter } from 'libs/end-to-end/src/ui-types';

export const usePromotionCopilotUpdateDropdownsEffect = ({
  setSelectedDepartments,
  setSelectedRoles,
  setSelectedLocations,
  shouldPrefillFilters,
}: {
  setSelectedDepartments: Setter<string[]>;
  setSelectedRoles: Setter<string[]>;
  setSelectedLocations: Setter<string[]>;
  shouldPrefillFilters: boolean;
}) => {
  const handler = useCallback(() => {
    setSelectedDepartments([]);
    setSelectedRoles([]);
    setSelectedLocations([]);
  }, [setSelectedDepartments, setSelectedRoles, setSelectedLocations]);

  useEffect(() => {
    if (!shouldPrefillFilters) {
      return;
    }
    handler();
  }, [handler, shouldPrefillFilters]);

  return handler;
};
